import { Component, Inject, OnInit, EventEmitter, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CheckoutApiService } from '@app/pages/checkout-app/services';
import { ABTestGroupDTO } from '../abtest-dialog/abtest-group.dto';
import { ToastService } from '@app/storybook/services/toast/toast.service';
import { PdqToastComponent } from '@app/storybook/components/toast/toast.component';
import { AbTestOptimizationTarget } from '@pdqdev/pdq-shared/dist/entities/AbTestOptimizationTargets';
import { TimeUnits } from '@utils/times-utils';
import { DropdownOption } from '@app/storybook/components/dropdown/dropdown.component';

@Component({
  selector: 'create-ab-test-group-dialog',
  templateUrl: './create-ab-test-group-dialog.component.html',
  styleUrls: ['./create-ab-test-group-dialog.component.scss'],
  standalone: false,
})
export class CreateAbTestGroupDialogComponent implements OnInit {
  name: string = '';
  description: string = '';
  idealWinner: 'A' | 'B' | undefined = undefined;
  optimizingFor: AbTestOptimizationTarget | undefined = undefined;

  idealWinnerDefaultOption: DropdownOption = undefined;
  optimizingForDefaultOption: DropdownOption = undefined;

  idealWinnerOptions = [
    { label: 'A', value: 'A' },
    { label: 'B', value: 'B' },
  ];
  optimizingForOptions = Object.entries(AbTestOptimizationTarget).map((entry) => ({
    value: entry[0],
    label: entry[1],
  }));

  @Output() onSave = new EventEmitter<ABTestGroupDTO>();
  constructor(
    public dialogRef: MatDialogRef<CreateAbTestGroupDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private checkoutApiService: CheckoutApiService,
    private toastService: ToastService,
  ) {}

  ngOnInit() {}

  save(event) {
    return this.checkoutApiService
      .post(`admin/v1/ab-test-group`, {
        name: this.name,
        description: this.description,
        idealWinner: this.idealWinner,
        optimizingFor: this.optimizingFor,
      })
      .subscribe(
        (response: ABTestGroupDTO) => {
          this.onSave.emit(response);
          this.dialogRef.close();
        },
        (err) => {
          this.toastService.show(PdqToastComponent, {
            position: 'top',
            message: 'Could not save A/B test group',
            mode: 'danger',
            duration: TimeUnits._SECOND_IN_MS * 3,
          });
        },
      );
  }
  changeIdealWinner(dropdownOption?: DropdownOption) {
    if (!dropdownOption) {
      this.idealWinnerDefaultOption = undefined;
      this.idealWinner = undefined;
      return;
    }
    this.idealWinnerDefaultOption = dropdownOption;
    this.idealWinner = dropdownOption.value as 'A' | 'B';
    return;
  }

  changeOptimizingFor(dropdownOption?: DropdownOption) {
    if (!dropdownOption) {
      this.optimizingForDefaultOption = undefined;
      this.optimizingFor = undefined;
      return;
    }
    this.optimizingForDefaultOption = dropdownOption;
    this.optimizingFor = dropdownOption.value as AbTestOptimizationTarget;
    return;
  }
}
